<template>
  <nav>
    <div>
      <button
        v-if="!footer"
        class="sm:hidden w-full md:w-auto hover:bg-blue-100 hover:text-blue-900 bg-blue-900 text-white md:bg-transparent md:text-blue-900 font-bold py-2 px-2 mt-2 md:mt-0 inline-flex items-center"
      >
        <span class="pl-2">Navigation</span>
      </button>
      <ul :class="navClass">
        <NavigationItem label="Overview" link="overview" :footer="footer" />
        <NavigationItem
          v-if="
            !(
              pageInfo.type == 'councilDistrict' ||
              pageInfo.sector == 'Alternative' ||
              pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
              pageInfo.slugvalue.toLowerCase() == 'alternative'
            )
          "
          class="notranslate"
          label="SPREE"
          link="spree"
          :footer="footer"
        />
        <NavigationItem
          v-if="
            pageInfo.sector == 'Alternative' ||
              pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
              pageInfo.slugvalue.toLowerCase() == 'citywide' ||
              pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
              pageInfo.slugvalue.toLowerCase() == 'innovation' ||
              pageInfo.slugvalue.toLowerCase() == 'alternative' ||
              pageInfo.slugvalue.toLowerCase() == 'network 12' ||
              pageInfo.slugvalue.toLowerCase() == 'network 14'
          "
          label="Alt Ed Progress Report"
          link="altedprogressreport"
          :footer="footer"
        />
        <NavigationItem
          label="Enrollment & Demographics"
          link="demographics"
          :footer="footer"
        />
        <NavigationItem
          v-if="
            !(
              pageInfo.type == 'councilDistrict' ||
              pageInfo.sector == 'Alternative' ||
              pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
              pageInfo.slugvalue.toLowerCase() == 'alternative'
            )
          "
          label="Reading & Language Arts"
          link="reading"
          :footer="footer"
        />
        <NavigationItem
          v-if="
            !(
              pageInfo.type == 'councilDistrict' ||
              pageInfo.sector == 'Alternative' ||
              pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
              pageInfo.slugvalue.toLowerCase() == 'alternative'
            )
          "
          label="Math & Science"
          link="mathscience"
          :footer="footer"
        />
        <NavigationItem
          v-if="
            pageInfo.type == 'citywide' ||
              (pageInfo.type == 'network' &&
                pageInfo.slugvalue.toLowerCase() !== 'opportunity') ||
              (pageInfo.type == 'sector' &&
                pageInfo.slugvalue.toLowerCase() !== 'alternative') ||
              pageInfo.type == 'studyArea' ||
              ((pageInfo.sector == 'Charter' ||
                pageInfo.sector == 'District') &&
                (pageInfo.schoolLevel == 'Elementary-Middle-High' ||
                  pageInfo.schoolLevel == 'Middle-High' ||
                  pageInfo.schoolLevel == 'High'))
          "
          label="College & Career"
          link="collegecareer"
          :footer="footer"
        />
        <NavigationItem
          v-if="
            !(
              pageInfo.type == 'councilDistrict' ||
              pageInfo.sector == 'Alternative' ||
              pageInfo.slugvalue.toLowerCase() == 'opportunity'
            )
          "
          label="Climate"
          link="climate"
          :footer="footer"
        />
        <NavigationItem
          v-if="pageInfo.type != 'councilDistrict'"
          label="Survey Results"
          link="surveyresults"
          :footer="footer"
        />
        <NavigationItem
          v-if="
            !(
              pageInfo.type == 'councilDistrict' || pageInfo.type == 'studyArea'
            )
          "
          label="More Info"
          link="moreinfo"
          :footer="footer"
        />
      </ul>
    </div>
  </nav>
</template>

<script>
import NavigationItem from '~/components/Navigation/NavigationItem.vue'

const navClasses = {
  header:
    'border border-blue-900 sm:border-0 py-2 px-6 sm:p-0 sm:flex sm:flex-wrap md:flex-no-wrap justify-between mb-4 text-sm',
  footer: 'my-6 block md:my-0 lg:flex lg:flex-wrap footer lg:w-2/3 mx-auto'
}

export default {
  components: {
    NavigationItem
  },
  props: ['footer'],
  computed: {
    navClass() {
      return navClasses[this.footer ? 'footer' : 'header']
    },
    pageInfo() {
      return this.$store.getters['subpage/selected/pageInfo']
    }
  },
  beforeMount() {
    if (!this.pageInfo.slugvalue) {
      this.$store.dispatch('subpage/selected/get_pageInfo', {
        slug: this.$route.params.subpage.toLowerCase()
      })
    }
  }
}
</script>
